// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { forgotPassword } from '../api/api';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/ForgotPassword.css';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    console.log("🔔 ForgotPassword submit:", email);
    setSubmitting(true);

    try {
      const res = await forgotPassword({ email });
      console.log("↪ forgotPassword response:", res.data);
      toast.success(res.data.message || "If that email exists, you’ll receive a link.");
    } catch (err) {
      console.error("ForgotPassword error:", err);
      toast.error("Error sending reset link. Check console.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fp-container">
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit} className="fp-form">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          disabled={submitting}
        />
        <button type="submit" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send Reset Link'}
        </button>
      </form>
      {/* Toasts will appear here */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
}
